import { MeritCompensationVisibilityLevel } from '@coin/shared/core/util-enums';
import { MercerEditableByType, MercerPermissionType, MercerSurveyDecision } from '@coin/shared/master-data/util';

interface CandidatePoolSeasonSetting {
  candidatePoolId: string;
  seasonSettingsId: string;
}

export class SeasonSetting {
  id: string;
  seasonId: string;

  constructor(initial?: Partial<SeasonSetting>) {
    Object.assign(this, initial);
  }
}

export class MeritSeasonSetting extends SeasonSetting {
  freezeDateAt: string;
  incentiveSeasonId: string;
  orientationValueExcessFactor: number;
  promotionOrientationValueExcessFactor: number;
  newHireEndDate: string;
  equityTeamRuleSetId: string;
  equityNotificationMailTemplateId: string;
  promotionRejectionMailTemplateId?: string | null;

  constructor(initial?: Partial<MeritSeasonSetting>) {
    super();
    Object.assign(this, initial);
  }
}

export class SpecialPaymentSetting extends SeasonSetting {
  proposalRequestDueDateAt: string;
  fxDateAt: string;
  hoHMailTemplateId: string;
  hrMailTemplateId: string;
  nMinus2MailTemplateId: string;
  rewardDate?: string;
  maxCashBudget?: number;
  minStockAward?: number;
  isRegionalHrHeadApprovalEnabled?: boolean;
  amountThresholdPercentage?: number;
  recentPaymentWindowMonths?: number;

  constructor(initial?: Partial<SpecialPaymentSetting>) {
    super();
    Object.assign(this, initial);
  }
}

export class IncentiveSeasonSetting extends SeasonSetting {
  maxTargetAchievement?: number;

  constructor(initial?: Partial<IncentiveSeasonSetting>) {
    super();
    Object.assign(this, initial);
  }
}

export class PositionEvaluationSetting extends SeasonSetting {
  usePopulationUpload: boolean;
  freezeDateAt: string;
  compensationVisibilityLevel: MeritCompensationVisibilityLevel;
  seasonSettingsCandidatePools: CandidatePoolSeasonSetting[];
  isPlacementSettingsEnabled: boolean;
  permissionType: MercerPermissionType;
  positionCountryEditableBy: MercerEditableByType;
  questionnaireDecision: MercerSurveyDecision;
  isAllowedToAddPositions: boolean;
  isConsistencyCheckingEnabled: boolean;
  isNewHireProcessEnabled: boolean;
  isQuestionnaireDisabledForGermanWithPartialEvaluation: boolean;
  isManagerAppReadOnly: boolean;
  isPromotionEnabled: boolean;
  season: { latestSeasonSetting: PositionEvaluationSetting };

  constructor(initial?: Partial<PositionEvaluationSetting>) {
    super();
    Object.assign(this, initial);
  }
}

export class ExceptionalRecognitionSeasonSetting extends SeasonSetting {
  fxDateAt: string;
  rewardDateAt: string;
  cfoApprovalThresholdAmount?: number;
  exrCAndBRuleSetId: string;
  transformationIncentiveHeadOfHrEmployeeId: string;
  transformationIncentiveHeadOfMaEmployeeId: string;
  cAndBCreationMailTemplateId: string;
  nMinus2MailTemplateId: string;
  hoHMailTemplateId: string;
  globalHrBpMailTemplateId: string;
  cAndBApproverMailTemplateId: string;
  headOfHrMailTemplateId: string;
  headOfMaMailTemplateId: string;

  constructor(initial?: Partial<ExceptionalRecognitionSeasonSetting>) {
    super();
    Object.assign(this, initial);
  }
}

export type GenericSeasonSettings =
  | MeritSeasonSetting
  | SpecialPaymentSetting
  | PositionEvaluationSetting
  | IncentiveSeasonSetting
  | ExceptionalRecognitionSeasonSetting;
